import { render, staticRenderFns } from "./activity-add-edit-question.vue?vue&type=template&id=5e6d5cfc&scoped=true&"
import script from "./activity-add-edit-question.vue?vue&type=script&lang=js&"
export * from "./activity-add-edit-question.vue?vue&type=script&lang=js&"
import style0 from "./activity-add-edit-question.vue?vue&type=style&index=0&id=5e6d5cfc&scoped=true&lang=scss&"
import style1 from "./activity-add-edit-question.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6d5cfc",
  null
  
)

component.options.__file = "activity-add-edit-question.vue"
export default component.exports